import React from "react";
import { Link, useNavigate } from "react-router-dom";
import providerRoutes from "../../../utlis/provider/routes.utlis.js";
import { routes } from "../../../utlis/user/routes.utlis";
import Header from "../../common/Header.js";
import Findcare1 from "../../../assets/images/findcare1.webp";
import careseekerca from "../../../assets/images/careseeker-CA.webp";
import ProcessImage from "../../../assets/images/Process.webp";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet-async";
import LocationsGrid from "./LocationsGrid.js";

const PageFlorida = () => {
  const navigate = useNavigate();

  //Add FAQ Schema
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What background checks should Florida caregivers have before hiring?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Most families in Florida look for caregivers who have passed identity verification, criminal background screening, and reference checks. For elderly care or medical-related tasks, CPR or first-aid training is strongly recommended."
        }
      },
      {
        "@type": "Question",
        "name": "Is live-in elder care common in Florida?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Due to Florida's large senior population, live-in caregiver jobs in Florida are increasingly common. Live-in care is often preferred for seniors who need consistent supervision or mobility assistance while remaining at home."
        }
      },
      {
        "@type": "Question",
        "name": "What is the difference between home care and home health care in Florida?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Home care focuses on daily living assistance such as bathing, companionship, and meal preparation, while home health care involves medical support provided by licensed professionals. Many families combine both, depending on care needs."
        }
      },
      {
        "@type": "Question",
        "name": "What should I include when posting a care job in Florida?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A strong job post includes care type, daily tasks, hours needed, location, mobility requirements, and whether overnight or live-in care is required. This helps match you with caregivers seeking caregiver jobs in Florida that align with your needs."
        }
      }
    ]
  };

  React.useEffect(() => {
    // inject JSON-LD into head
    const id = "faq-schema-florida-careseeker";
    if (!document.getElementById(id)) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(faqSchema);
      document.head.appendChild(script);
    }
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <Helmet script={[{type: "application/ld+json", innerHTML: JSON.stringify(faqSchema)}]}>
        <title>Post Jobs & Hire Trusted Caregivers In Florida</title>
        <meta
          name="description"
          content="Your search for experienced caregivers in Florida ends with Care-Exchange. Seamlessly connect with professionals offering caregiving services. Start today!"
        />
        <meta name="keywords" content="caregiver florida, florida elder care, elderly care florida, florida elderly care, florida home care for the elderly, caregiver jobs in florida, caregiver job in florida, live-in caregiver jobs in florida, private caregiver jobs in florida, caregiver jobs in orlando florida"/>
        <link rel="canonical" href="https://care-exchange.com/find-care/FL" />
      </Helmet>
      <Header></Header>
      <div className="cal-hero-section">
        <div className="cal-hero-media">
          <img src={careseekerca} alt="" />
        </div>
        <div className="cal-hero-content">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="cal-hero-text">
                  <h1>Hire Reliable In-Home Caregivers In Florida</h1>

                  <p>
                    Care-Exchange helps families & individuals quickly connect
                    with dependable <b>caregivers in Florida</b>. Whether you’re
                    managing aging parents, need recovery care, or daily
                    assistance, our platform enables you to post care jobs and
                    reach qualified caregivers statewide.
                  </p>
                  <button
                    className="cal-hero-btn"
                    style={{ border: "none" }}
                    type="button"
                    onClick={() => {
                      localStorage.setItem(
                        "findJobCare",
                        JSON.stringify({
                          lat: "",
                          lng: "",
                          address: "",
                          state: "",
                        })
                      );
                      navigate(routes.login);
                    }}
                  >
                    Post a Care Job in Florida
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cal-service-section">
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-md-12">
              <div className="cal-service-text">
                <h2>
                  Helping You Connect With The Skilled Caregivers In Florida
                </h2>

                <p>
                  Florida has one of the largest senior populations in the
                  U.S.A., making access to reliable care more important than
                  ever. Care-Exchange supports families by connecting them with
                  caregivers experienced in <b>Florida elder care</b>, who can
                  provide assistance that adapts to both short-term and
                  long-term needs. From urban centers to coastal communities,
                  careseeker families can easily find{" "}
                  <b>Florida home care for the elderly</b> that fits their
                  lifestyle and expectations.
                </p>

                <ul class="feature-list">
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    In-Home Support
                  </li>
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    Personal Care Assistance
                  </li>
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    Companionship & Daily Help
                  </li>
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    Respite Care
                  </li>

                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    Child Care
                  </li>

                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    Elder Care
                  </li>

                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    Pet Support
                  </li>
                </ul>
                <button
                  className="cal-Book-btn"
                  style={{ border: "none" }}
                  type="button"
                  onClick={() => {
                    localStorage.setItem(
                      "findJobCare",
                      JSON.stringify({
                        lat: "",
                        lng: "",
                        address: "",
                        state: "",
                      })
                    );
                    navigate(routes.login);
                  }}
                >
                  Find Caregivers Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ca-howitwork-section">
        <div className="container">
          <div className="ca-howitwork-page-heading text-center">
            <h2>How Florida Families Post Jobs & Hire Caregivers With Us?</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="cahowitwork-box">
                <div className="ca-steps" role="list">
                  <div className="ca-step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.41016 22C3.41016 18.13 7.26015 15 12.0002 15C12.9602 15 13.8902 15.13 14.7602 15.37"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22 18C22 18.32 21.96 18.63 21.88 18.93C21.79 19.33 21.63 19.72 21.42 20.06C20.73 21.22 19.46 22 18 22C16.97 22 16.04 21.61 15.34 20.97C15.04 20.71 14.78 20.4 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.92 14.43 15.93 15.13 15.21C15.86 14.46 16.88 14 18 14C19.18 14 20.25 14.51 20.97 15.33C21.61 16.04 22 16.98 22 18Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19.4897 17.98H16.5098"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18 16.52V19.51"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Create Your Account</h3>
                      <p>
                        Get started with instant access to{" "}
                        <b>caregiver in Florida.</b>
                      </p>
                    </div>
                  </div>

                  <div className="ca-step" role="listitem">
                    <div className="ca-icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.3701 8.88H17.6201"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.37988 8.88L7.12988 9.63L9.37988 7.38"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.3701 15.88H17.6201"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.37988 15.88L7.12988 16.63L9.37988 14.38"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Post Your Care Job</h3>
                      <p>
                        Define care needs, schedule, location, and preferences,
                        and your post becomes visible to caregivers.
                      </p>
                    </div>
                  </div>

                  <div className="ca-step" role="listitem">
                    <div className="ca-icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.41016 22C3.41016 18.13 7.26018 15 12.0002 15"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.2 21.4C19.9673 21.4 21.4 19.9673 21.4 18.2C21.4 16.4327 19.9673 15 18.2 15C16.4327 15 15 16.4327 15 18.2C15 19.9673 16.4327 21.4 18.2 21.4Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22 22L21 21"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Review & Connect</h3>
                      <p>
                        Compare experience, availability, and reviews to find
                        the right caregiver fit.
                      </p>
                    </div>
                  </div>

                  <div className="ca-step" role="listitem">
                    <div className="ca-icon" aria-hidden="true">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_240_4385)">
                          <path
                            d="M25 19L20 24L12 22L5 17"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.08496 8.82875L16 7L22.915 8.82875"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.29634 7.55248L1.10634 13.935C0.987789 14.172 0.968197 14.4465 1.05187 14.698C1.13555 14.9495 1.31565 15.1575 1.55259 15.2762L5.00009 17L9.08509 8.82873L5.63884 7.10623C5.5214 7.04733 5.3935 7.01216 5.26246 7.00271C5.13142 6.99326 4.9998 7.00973 4.87512 7.05117C4.75045 7.09262 4.63516 7.15822 4.53585 7.24424C4.43654 7.33025 4.35515 7.435 4.29634 7.55248Z"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M27 17L30.4475 15.2762C30.6845 15.1575 30.8646 14.9495 30.9483 14.698C31.0319 14.4465 31.0123 14.172 30.8938 13.935L27.7038 7.55248C27.645 7.435 27.5636 7.33025 27.4643 7.24424C27.365 7.15822 27.2497 7.09262 27.125 7.05117C27.0003 7.00973 26.8687 6.99326 26.7377 7.00271C26.6066 7.01216 26.4787 7.04733 26.3613 7.10623L22.915 8.82873L27 17Z"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M23.0001 9H18.0001L12.2926 14.5363C12.1865 14.6423 12.1056 14.7709 12.0559 14.9124C12.0063 15.054 11.9891 15.2049 12.0056 15.354C12.0222 15.5031 12.0721 15.6465 12.1516 15.7737C12.2312 15.9009 12.3383 16.0086 12.4651 16.0888C14.6538 17.4875 17.6251 17.3912 20.0001 15L25.0001 19L27.0001 17"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.5075 27L10.2925 25.6963L7 23.3438"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_240_4385">
                            <rect width="32" height="32" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div>
                      <h3>Hire with Confidence</h3>
                      <p>
                        Communicate directly and finalize care arrangements
                        accordingly.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ca-howitwork-media">
                <img src={ProcessImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cal-Whylocal-section">
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-md-12">
              <div className="cal-Whylocal-text">
                <h2>Why Families Choose Florida Home Care For The Elderly</h2>

                <div className="Whylocal-list">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="Whylocal-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        <b>Local Knowledge & Community Fit -</b> Caregivers
                        familiar with Florida neighborhoods provide care that
                        aligns with your lifestyle, culture, and pace of life.
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="Whylocal-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        <b>Understanding of Regulations -</b> Our caregivers are
                        informed about the U.S.A. care standards, helping
                        families navigate expectations with confidence.
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="Whylocal-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        <b>Flexible Availability-</b>From part-time help to
                        full-time private home care in Florida, find caregivers
                        who adapt to your routine.
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="Whylocal-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        <b>Availability for Varied Care Models -</b> Families
                        can hire hourly, overnight, or live-in caregiver in
                        Florida, depending on care intensity.
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="Whylocal-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        <b>HIPAA-Compliant & Secure -</b> Every profile is
                        background-verified, private, and designed to protect
                        sensitive personal information.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cal-getservice-section">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="cal-getservice-item">
                <h2>Care Services That Adapt As Per Changing Needs</h2>
                <div className="cal-getservice-action">
                  <a href="#" className="cal-Book-btn">
                    Post Care Job Today
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-8">
              <div className="cal-getservice-desc">
                <p>
                  Florida families often require care that adjusts with changing
                  health, seasonal residency, or family availability.
                  Care-Exchange allows you to post flexible care jobs, from
                  daily assistance to extended{" "}
                  <b>Florida home care for the elderly</b>, so you can hire
                  caregivers as per your needs.
                </p>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="cal-getservice-card">
                    <div className="cal-getservice-icon">
                      <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M32 3.19922C34.21 3.19922 36 4.98922 36 7.19922C36 9.40922 34.21 11.1992 32 11.1992C29.79 11.1992 28 9.40922 28 7.19922C28 4.98922 29.79 3.19922 32 3.19922ZM4 12.7992C6.21 12.7992 8 14.5892 8 16.7992V32.8192C8 34.5192 8.67 36.1492 9.87 37.3492L14.98 42.4592C15.81 43.2892 17.11 43.4192 18.08 42.7692C19.37 41.9092 19.55 40.0792 18.45 38.9892C17.72 38.2592 16.14 36.6792 13.73 34.2692C12.48 33.0192 12.48 30.9892 13.73 29.7392C14.98 28.4892 17.01 28.4892 18.26 29.7392C20.67 32.1492 22.25 33.7292 22.98 34.4592L25.51 36.9892C27.61 39.0892 28.79 41.9392 28.79 44.9092V52.7992C28.79 55.4492 26.64 57.5992 23.99 57.5992H17.32C15.62 57.5992 13.99 56.9292 12.79 55.7292L2.81 45.7392C1.01 43.9392 0 41.4992 0 38.9492V16.7992C0 14.5892 1.79 12.7992 4 12.7992ZM60 12.7992C62.21 12.7992 64 14.5892 64 16.7992V38.9492C64 41.4992 62.99 43.9392 61.19 45.7392L51.2 55.7292C50 56.9292 48.37 57.5992 46.67 57.5992H40C37.35 57.5992 35.2 55.4492 35.2 52.7992V44.9092C35.2 41.9392 36.38 39.0892 38.48 36.9892L41.01 34.4592C41.74 33.7292 43.32 32.1492 45.73 29.7392C46.98 28.4892 49.01 28.4892 50.26 29.7392C51.51 30.9892 51.51 33.0192 50.26 34.2692C47.85 36.6792 46.27 38.2592 45.54 38.9892C44.44 40.0892 44.62 41.9092 45.91 42.7692C46.88 43.4192 48.18 43.2892 49.01 42.4592L54.12 37.3492C55.32 36.1492 55.99 34.5192 55.99 32.8192L56 16.7992C56 14.5892 57.79 12.7992 60 12.7992ZM38.45 21.2992L36.47 19.6292L37.58 28.5092C37.74 29.8292 36.81 31.0192 35.5 31.1892C34.19 31.3592 32.99 30.4192 32.82 29.1092L32.38 25.6092H31.62L31.18 29.1092C31.02 30.4292 29.82 31.3592 28.5 31.1892C27.18 31.0192 26.25 29.8292 26.42 28.5092L27.53 19.6292L25.55 21.2992C24.54 22.1592 23.02 22.0292 22.17 21.0192C21.32 20.0092 21.44 18.4892 22.45 17.6392L25.24 15.2792C27.13 13.6792 29.53 12.7992 32 12.7992C34.47 12.7992 36.87 13.6792 38.76 15.2692L41.55 17.6292C42.56 18.4892 42.69 19.9992 41.83 21.0092C40.97 22.0192 39.46 22.1492 38.45 21.2892V21.2992Z"
                          fill="#132A3A"
                        />
                      </svg>
                    </div>
                    <div className="cal-getservice-content">
                      <h3>Child & Family Care</h3>
                      <p>Dependable in-home support</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="cal-getservice-card">
                    <div className="cal-getservice-icon">
                      <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.2002 8.80039C27.2002 7.47039 28.2702 6.40039 29.6002 6.40039H34.4002C35.7302 6.40039 36.8002 7.47039 36.8002 8.80039V14.4004H42.4002C43.7302 14.4004 44.8002 15.4704 44.8002 16.8004V21.6004C44.8002 22.9304 43.7302 24.0004 42.4002 24.0004H36.8002V29.6004C36.8002 30.9304 35.7302 32.0004 34.4002 32.0004H29.6002C28.2702 32.0004 27.2002 30.9304 27.2002 29.6004V24.0004H21.6002C20.2702 24.0004 19.2002 22.9304 19.2002 21.6004V16.8004C19.2002 15.4704 20.2702 14.4004 21.6002 14.4004H27.2002V8.80039ZM9.8702 44.8004L14.1202 40.5504C16.5202 38.1504 19.7802 36.8004 23.1702 36.8004H38.4002C40.1702 36.8004 41.6002 38.2304 41.6002 40.0004C41.6002 41.7704 40.1702 43.2004 38.4002 43.2004H31.2002C29.8702 43.2004 28.8002 44.2704 28.8002 45.6004C28.8002 46.9304 29.8702 48.0004 31.2002 48.0004H42.4602L54.4302 39.1804C56.2102 37.8704 58.7102 38.2504 60.0202 40.0304C61.3302 41.8104 60.9502 44.3104 59.1702 45.6204L46.5102 54.9504C44.1702 56.6704 41.3502 57.6004 38.4402 57.6004H6.4002C4.6302 57.6004 3.2002 56.1704 3.2002 54.4004V48.0004C3.2002 46.2304 4.6302 44.8004 6.4002 44.8004H9.8702Z"
                          fill="#132A3A"
                        />
                      </svg>
                    </div>
                    <div className="cal-getservice-content">
                      <h3>Medical Recovery Assistance</h3>
                      <p>Post-surgery and transitional care</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="cal-getservice-card">
                    <div className="cal-getservice-icon">
                      <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29.85 15.6909C31.28 19.9809 29.82 24.3109 26.59 25.3709C23.36 26.4309 19.58 23.8109 18.15 19.5209C16.72 15.2309 18.18 10.9009 21.41 9.84085C24.64 8.78085 28.42 11.4009 29.85 15.6909ZM16.44 26.2609C18.33 29.5009 17.87 33.2709 15.42 34.6709C12.97 36.0709 9.45 34.5809 7.57 31.3409C5.69 28.1009 6.14 24.3309 8.59 22.9309C11.04 21.5309 14.56 23.0209 16.44 26.2609ZM13.32 46.5209C18.56 32.3909 27.87 28.8009 32 28.8009C36.13 28.8009 45.44 32.3909 50.68 46.5209C51.04 47.4909 51.2 48.5309 51.2 49.5709V49.7309C51.2 52.3109 49.11 54.4009 46.53 54.4009C45.38 54.4009 44.24 54.2609 43.13 53.9809L34.33 51.7809C32.8 51.4009 31.2 51.4009 29.67 51.7809L20.87 53.9809C19.76 54.2609 18.62 54.4009 17.47 54.4009C14.89 54.4009 12.8 52.3109 12.8 49.7309V49.5709C12.8 48.5309 12.96 47.4909 13.32 46.5209ZM48.58 34.6709C46.13 33.2709 45.67 29.5009 47.56 26.2609C49.45 23.0209 52.96 21.5309 55.41 22.9309C57.86 24.3309 58.32 28.1009 56.43 31.3409C54.54 34.5809 51.03 36.0709 48.58 34.6709ZM37.41 25.3709C34.18 24.3109 32.72 19.9809 34.15 15.6909C35.58 11.4009 39.36 8.78085 42.59 9.84085C45.82 10.9009 47.28 15.2309 45.85 19.5209C44.42 23.8109 40.64 26.4309 37.41 25.3709Z"
                          fill="#132A3A"
                        />
                      </svg>
                    </div>
                    <div className="cal-getservice-content">
                      <h3>Pet Care</h3>
                      <p>Trusted care while traveling or working</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="cal-getservice-card">
                    <div className="cal-getservice-icon">
                      <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M32.7998 3.19922C35.8898 3.19922 38.3998 5.70922 38.3998 8.79922C38.3998 11.8892 35.8898 14.3992 32.7998 14.3992C29.7098 14.3992 27.1998 11.8892 27.1998 8.79922C27.1998 5.70922 29.7098 3.19922 32.7998 3.19922ZM23.9998 30.0692L19.3698 36.3092C18.3198 37.7292 16.3098 38.0292 14.8898 36.9692C13.4698 35.9092 13.1698 33.9092 14.2298 32.4892L21.2798 22.9892C23.7998 19.5992 27.7698 17.5992 31.9998 17.5992C36.2298 17.5992 40.1998 19.5992 42.7198 22.9892L49.7698 32.4892C50.8198 33.9092 50.5298 35.9092 49.1098 36.9692C47.6898 38.0292 45.6898 37.7292 44.6298 36.3092L39.9998 30.0692V57.5992C39.9998 59.3692 38.5698 60.7992 36.7998 60.7992C35.0298 60.7992 33.5998 59.3692 33.5998 57.5992V41.5992C33.5998 40.7192 32.8798 39.9992 31.9998 39.9992C31.1198 39.9992 30.3998 40.7192 30.3998 41.5992V57.5992C30.3998 59.3692 28.9698 60.7992 27.1998 60.7992C25.4298 60.7992 23.9998 59.3692 23.9998 57.5992V30.0692ZM48.7998 44.7992C48.3598 44.7992 47.9998 45.1592 47.9998 45.5992C47.9998 46.9292 46.9298 47.9992 45.5998 47.9992C44.2698 47.9992 43.1998 46.9292 43.1998 45.5992C43.1998 42.5092 45.7098 39.9992 48.7998 39.9992C51.8898 39.9992 54.3998 42.5092 54.3998 45.5992V58.3992C54.3998 59.7292 53.3298 60.7992 51.9998 60.7992C50.6698 60.7992 49.5998 59.7292 49.5998 58.3992V45.5992C49.5998 45.1592 49.2398 44.7992 48.7998 44.7992Z"
                          fill="#132A3A"
                        />
                      </svg>
                    </div>
                    <div className="cal-getservice-content">
                      <h3>Senior & Aging Care</h3>
                      <p>Ongoing support for Florida elderly care</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="careseekers-testi-section">
        <div className="container">
          <h2>Real Experiences From Florida People About Care-Exchange</h2>
          <div className="ro">
            <CarouselProvider
              naturalSlideWidth={100}
              naturalSlideHeight={100}
              totalSlides={4}
              visibleSlides={window.innerWidth < 768 ? 1 : 3}
              isPlaying={true}
              interval={4000}
              infinite={true}
            >
              <Slider>
                <Slide index={0}>
                  <div className="co mx-2">
                    <div className="testi-single-box h-100">
                      <div className="testi-icon">
                        <svg
                          width="54"
                          height="40"
                          viewBox="0 0 54 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.695 4.12089V26.7858C23.6916 30.0635 22.388 33.206 20.0704 35.5237C17.7527 37.8414 14.6102 39.145 11.3324 39.1484C10.7859 39.1484 10.2619 38.9313 9.87547 38.5449C9.48905 38.1585 9.272 37.6344 9.272 37.088C9.272 36.5415 9.48905 36.0174 9.87547 35.631C10.2619 35.2446 10.7859 35.0275 11.3324 35.0275C13.5183 35.0275 15.6146 34.1592 17.1602 32.6135C18.7058 31.0679 19.5742 28.9716 19.5742 26.7858V24.7253H4.12088C3.02796 24.7253 1.97979 24.2912 1.20698 23.5183C0.434163 22.7455 0 21.6974 0 20.6045V4.12089C0 3.02796 0.434163 1.9798 1.20698 1.20698C1.97979 0.434162 3.02796 0 4.12088 0H19.5742C20.6671 0 21.7153 0.434162 22.4881 1.20698C23.2609 1.9798 23.695 3.02796 23.695 4.12089ZM49.4505 0H33.9973C32.9043 0 31.8562 0.434162 31.0833 1.20698C30.3105 1.9798 29.8764 3.02796 29.8764 4.12089V20.6045C29.8764 21.6974 30.3105 22.7455 31.0833 23.5183C31.8562 24.2912 32.9043 24.7253 33.9973 24.7253H49.4505V26.7858C49.4505 28.9716 48.5824 31.0679 47.0365 32.6135C45.491 34.1592 43.3946 35.0275 41.2088 35.0275C40.6623 35.0275 40.1382 35.2446 39.7518 35.631C39.3655 36.0174 39.1484 36.5415 39.1484 37.088C39.1484 37.6344 39.3655 38.1585 39.7518 38.5449C40.1382 38.9313 40.6623 39.1484 41.2088 39.1484C44.4866 39.145 47.629 37.8414 49.9468 35.5237C52.2646 33.206 53.5679 30.0635 53.5714 26.7858V4.12089C53.5714 3.02796 53.1371 1.9798 52.3644 1.20698C51.5916 0.434162 50.5433 0 49.4505 0Z"
                            fill="#45B14A"
                          />
                        </svg>
                      </div>
                      <div className="testi-content">
                        <p className="testi-text">
                          Finding dependable{" "}
                          <b>Florida home care for the elderly</b>
                          felt overwhelming until we used Care-Exchange. Within
                          days, we were speaking directly with caregivers who
                          understood senior care needs and Florida’s lifestyle.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slide>
                <Slide index={1}>
                  <div className="co mx-2">
                    <div className="testi-single-box h-100">
                      <div className="testi-icon">
                        <svg
                          width="54"
                          height="40"
                          viewBox="0 0 54 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.695 4.12089V26.7858C23.6916 30.0635 22.388 33.206 20.0704 35.5237C17.7527 37.8414 14.6102 39.145 11.3324 39.1484C10.7859 39.1484 10.2619 38.9313 9.87547 38.5449C9.48905 38.1585 9.272 37.6344 9.272 37.088C9.272 36.5415 9.48905 36.0174 9.87547 35.631C10.2619 35.2446 10.7859 35.0275 11.3324 35.0275C13.5183 35.0275 15.6146 34.1592 17.1602 32.6135C18.7058 31.0679 19.5742 28.9716 19.5742 26.7858V24.7253H4.12088C3.02796 24.7253 1.97979 24.2912 1.20698 23.5183C0.434163 22.7455 0 21.6974 0 20.6045V4.12089C0 3.02796 0.434163 1.9798 1.20698 1.20698C1.97979 0.434162 3.02796 0 4.12088 0H19.5742C20.6671 0 21.7153 0.434162 22.4881 1.20698C23.2609 1.9798 23.695 3.02796 23.695 4.12089ZM49.4505 0H33.9973C32.9043 0 31.8562 0.434162 31.0833 1.20698C30.3105 1.9798 29.8764 3.02796 29.8764 4.12089V20.6045C29.8764 21.6974 30.3105 22.7455 31.0833 23.5183C31.8562 24.2912 32.9043 24.7253 33.9973 24.7253H49.4505V26.7858C49.4505 28.9716 48.5824 31.0679 47.0365 32.6135C45.491 34.1592 43.3946 35.0275 41.2088 35.0275C40.6623 35.0275 40.1382 35.2446 39.7518 35.631C39.3655 36.0174 39.1484 36.5415 39.1484 37.088C39.1484 37.6344 39.3655 38.1585 39.7518 38.5449C40.1382 38.9313 40.6623 39.1484 41.2088 39.1484C44.4866 39.145 47.629 37.8414 49.9468 35.5237C52.2646 33.206 53.5679 30.0635 53.5714 26.7858V4.12089C53.5714 3.02796 53.1371 1.9798 52.3644 1.20698C51.5916 0.434162 50.5433 0 49.4505 0Z"
                            fill="#45B14A"
                          />
                        </svg>
                      </div>
                      <div className="testi-content">
                        <p className="testi-text">
                          We appreciated how transparent the process was.
                          Instead of dealing with multiple agencies, we posted
                          once and connected with caregivers already seeking
                          <b>caregiver jobs in Florida</b>. It saved us time and
                          stress.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slide>
                <Slide index={2}>
                  <div className="co mx-2">
                    <div className="testi-single-box h-100">
                      <div className="testi-icon">
                        <svg
                          width="54"
                          height="40"
                          viewBox="0 0 54 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.695 4.12089V26.7858C23.6916 30.0635 22.388 33.206 20.0704 35.5237C17.7527 37.8414 14.6102 39.145 11.3324 39.1484C10.7859 39.1484 10.2619 38.9313 9.87547 38.5449C9.48905 38.1585 9.272 37.6344 9.272 37.088C9.272 36.5415 9.48905 36.0174 9.87547 35.631C10.2619 35.2446 10.7859 35.0275 11.3324 35.0275C13.5183 35.0275 15.6146 34.1592 17.1602 32.6135C18.7058 31.0679 19.5742 28.9716 19.5742 26.7858V24.7253H4.12088C3.02796 24.7253 1.97979 24.2912 1.20698 23.5183C0.434163 22.7455 0 21.6974 0 20.6045V4.12089C0 3.02796 0.434163 1.9798 1.20698 1.20698C1.97979 0.434162 3.02796 0 4.12088 0H19.5742C20.6671 0 21.7153 0.434162 22.4881 1.20698C23.2609 1.9798 23.695 3.02796 23.695 4.12089ZM49.4505 0H33.9973C32.9043 0 31.8562 0.434162 31.0833 1.20698C30.3105 1.9798 29.8764 3.02796 29.8764 4.12089V20.6045C29.8764 21.6974 30.3105 22.7455 31.0833 23.5183C31.8562 24.2912 32.9043 24.7253 33.9973 24.7253H49.4505V26.7858C49.4505 28.9716 48.5824 31.0679 47.0365 32.6135C45.491 34.1592 43.3946 35.0275 41.2088 35.0275C40.6623 35.0275 40.1382 35.2446 39.7518 35.631C39.3655 36.0174 39.1484 36.5415 39.1484 37.088C39.1484 37.6344 39.3655 38.1585 39.7518 38.5449C40.1382 38.9313 40.6623 39.1484 41.2088 39.1484C44.4866 39.145 47.629 37.8414 49.9468 35.5237C52.2646 33.206 53.5679 30.0635 53.5714 26.7858V4.12089C53.5714 3.02796 53.1371 1.9798 52.3644 1.20698C51.5916 0.434162 50.5433 0 49.4505 0Z"
                            fill="#45B14A"
                          />
                        </svg>
                      </div>
                      <div className="testi-content">
                        <p className="testi-text">
                          Our family needed part-time support that could
                          eventually become full-time. Care-Exchange made it
                          easy to hire someone experienced in{" "}
                          <b>Florida elderly care</b> who was open to flexible
                          arrangements.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slide>

                <Slide index={3}>
                  <div className="co mx-2">
                    <div className="testi-single-box h-100">
                      <div className="testi-icon">
                        <svg
                          width="54"
                          height="40"
                          viewBox="0 0 54 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.695 4.12089V26.7858C23.6916 30.0635 22.388 33.206 20.0704 35.5237C17.7527 37.8414 14.6102 39.145 11.3324 39.1484C10.7859 39.1484 10.2619 38.9313 9.87547 38.5449C9.48905 38.1585 9.272 37.6344 9.272 37.088C9.272 36.5415 9.48905 36.0174 9.87547 35.631C10.2619 35.2446 10.7859 35.0275 11.3324 35.0275C13.5183 35.0275 15.6146 34.1592 17.1602 32.6135C18.7058 31.0679 19.5742 28.9716 19.5742 26.7858V24.7253H4.12088C3.02796 24.7253 1.97979 24.2912 1.20698 23.5183C0.434163 22.7455 0 21.6974 0 20.6045V4.12089C0 3.02796 0.434163 1.9798 1.20698 1.20698C1.97979 0.434162 3.02796 0 4.12088 0H19.5742C20.6671 0 21.7153 0.434162 22.4881 1.20698C23.2609 1.9798 23.695 3.02796 23.695 4.12089ZM49.4505 0H33.9973C32.9043 0 31.8562 0.434162 31.0833 1.20698C30.3105 1.9798 29.8764 3.02796 29.8764 4.12089V20.6045C29.8764 21.6974 30.3105 22.7455 31.0833 23.5183C31.8562 24.2912 32.9043 24.7253 33.9973 24.7253H49.4505V26.7858C49.4505 28.9716 48.5824 31.0679 47.0365 32.6135C45.491 34.1592 43.3946 35.0275 41.2088 35.0275C40.6623 35.0275 40.1382 35.2446 39.7518 35.631C39.3655 36.0174 39.1484 36.5415 39.1484 37.088C39.1484 37.6344 39.3655 38.1585 39.7518 38.5449C40.1382 38.9313 40.6623 39.1484 41.2088 39.1484C44.4866 39.145 47.629 37.8414 49.9468 35.5237C52.2646 33.206 53.5679 30.0635 53.5714 26.7858V4.12089C53.5714 3.02796 53.1371 1.9798 52.3644 1.20698C51.5916 0.434162 50.5433 0 49.4505 0Z"
                            fill="#45B14A"
                          />
                        </svg>
                      </div>
                      <div className="testi-content">
                        <p className="testi-text">
                          What stood out was the quality of candidates. We found
                          caregivers actively looking for{" "}
                          <b>private caregiver jobs in Florida</b>, which made
                          the relationship more personal and trustworthy from
                          day one.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slide>
              </Slider>
              <div className="carousel-arrows">
                <ButtonBack className="carousel-btn prev">‹</ButtonBack>
                <ButtonNext className="carousel-btn next">›</ButtonNext>
              </div>
            </CarouselProvider>
          </div>
        </div>
      </div>

       {/* ── Locations Section ── */}
        <LocationsGrid currentCode="FL" />
              
      <div className="faq-section">
        <div className="container">
          <div className="faq-page-heading">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="faq-page-accordion">
            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                What background checks should Florida caregivers have before
                hiring?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Most families in Florida look for caregivers who have passed
                  identity verification, criminal background screening, and
                  reference checks. For elderly care or medical-related tasks,
                  CPR or first-aid training is strongly recommended.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                Is live-in elder care common in Florida?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Yes. Due to Florida’s large senior population,{" "}
                  <b>live-in caregiver jobs in Florida</b> are increasingly
                  common. Live-in care is often preferred for seniors who need
                  consistent supervision or mobility assistance while remaining
                  at home.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                What is the difference between home care and home health care in
                Florida?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Home care focuses on daily living assistance such as bathing,
                  companionship, and meal preparation, while home health care
                  involves medical support provided by licensed professionals.
                  Many families combine both, depending on care needs.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                What should I include when posting a care job in Florida?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  A strong job post includes care type, daily tasks, hours
                  needed, location, mobility requirements, and whether overnight
                  or live-in care is required. This helps match you with
                  caregivers seeking <b>caregiver jobs in Florida</b> that align
                  with your needs.
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>

      <div className="post-job-section">
        <div className="container">
          <h5 className="fw-bold mb-3">
            Start Your Care Search With Confidence Here
          </h5>

          <Link to={providerRoutes.routes.providerRegister} className="btn-gr">
            Post Your Florida Care Job Today
          </Link>
        </div>
      </div>

      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageFlorida;
